var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('main-section', {
    staticClass: "main-section--sm",
    scopedSlots: _vm._u([{
      key: "tit",
      fn: function () {
        return [_vm._v(" 협력 연구 등을 위해 지역의 대학, 연구소, 진흥원, 센터 등과 "), _c('br'), _vm._v(" 활발한 교류로 "), _c('span', {
          staticClass: "primary--text"
        }, [_vm._v("기술력 축적")]), _vm._v(" 및 "), _c('span', {
          staticClass: "primary--text"
        }, [_vm._v("신제품 출시")])];
      },
      proxy: true
    }])
  }, [_c('v-row', {
    staticClass: "row--lg",
    attrs: {
      "justify": "space-between",
      "align": "center"
    }
  }, _vm._l(_vm.items, function (item, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "6",
        "xl": "auto"
      }
    }, [_c('img', {
      staticClass: "product-image",
      attrs: {
        "src": item.image,
        "alt": ""
      }
    }), _c('div', {
      staticClass: "txt txt--lg grey--text text--darken-4 text-center mt-10px"
    }, [_vm._v(" " + _vm._s(item.name) + " ")])]);
  }), 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }